import React from 'react';

import PropTypes from 'prop-types';

import { SortableContainer, SortableElement } from 'react-sortable-hoc';

import { BusinessFilePropType } from 'components/modules/files/types/files';

import Deck from './components/Deck';
import DeckItem from './components/DeckItem';
import Utils from '../../../../../libs/utils';

import './ImagesDeck.scss';

const SortableBusinessFile = SortableElement(({ file, onFileEdit }) => {
  return <DeckItem file={file} onFileEdit={onFileEdit} />;
});

const SortableBusinessFileList = SortableContainer(({ files, onFileEdit }) => {
  return (
    <Deck>
      {files.map((file, idx) => (
        <SortableBusinessFile key={file.file} file={file} index={idx} onFileEdit={onFileEdit} />
      ))}
    </Deck>
  );
});

const propTypes = {
  files: PropTypes.arrayOf(BusinessFilePropType).isRequired,
  onUpdateFilesOrdering: PropTypes.func.isRequired,
  onFileEdit: PropTypes.func,
};

const defaultProps = {
  onFileEdit: null,
};

export default function ImagesDeck({ files, onUpdateFilesOrdering, onFileEdit }) {
  const onSortImages = ({ oldIndex, newIndex }) => {
    if (oldIndex === newIndex) {
      return;
    }
    onUpdateFilesOrdering(Utils.moveListItem(files, oldIndex, newIndex, true));
  };

  return (
    <div className="images-deck">
      <SortableBusinessFileList
        helperClass="images-deck-modal-sorting"
        axis="x"
        lockAxis="x"
        files={files}
        onSortEnd={onSortImages}
        onFileEdit={onFileEdit}
      />
    </div>
  );
}

ImagesDeck.propTypes = propTypes;
ImagesDeck.defaultProps = defaultProps;
